import { useCallback, useEffect, useMemo, useState } from 'react';
import { translateTextBatch } from './useUniversalTranslation';

// Small cached label layer for forms that do not already own a translation dictionary.
export default function useModuleLabels(labels, language = 'en') {
    const keys = useMemo(() => Object.keys(labels), [labels]);
    const english = useMemo(() => keys.map(key => labels[key]), [keys, labels]);
    const [values, setValues] = useState(labels);

    useEffect(() => {
        const controller = new AbortController();
        if (!language || language === 'en') {
            setValues(labels);
            return () => controller.abort();
        }
        translateTextBatch(english, language, 'en', { signal: controller.signal })
            .then(translated => {
                if (controller.signal.aborted) return;
                setValues(keys.reduce((result, key, index) => {
                    result[key] = translated[index] || labels[key];
                    return result;
                }, {}));
            })
            .catch(error => {
                if (error.name !== 'AbortError') setValues(labels);
            });
        return () => controller.abort();
    }, [english, keys, labels, language]);

    return useCallback(key => values[key] || labels[key] || key, [labels, values]);
}
